import { v4 as uuidv4 } from 'uuid'
import pL from 'js-regex-pl'
import { notification } from 'antd'
import moment from 'moment'
import { WordList } from '../../shared/types/api'

let WordUtils = {
    /**
     * Создание нового слова
     * @param
     * @returns {{prewEngWord: string, rusWord: string, prewRusWord: string, engWord: string, editMode: boolean, id}}
     */
    createNewWord(listId: any) {
        return {
            id: uuidv4(),
            engWord: '',
            prevEngWord: '',
            rusWord: '',
            prevRusWord: '',
            editMode: true,
            listId: listId,
            loading: false,
            created: moment(new Date()).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        }
    },

    /**
     * Создание нового слова
     * @param
     * @returns {{prewEngWord: string, rusWord: string, prewRusWord: string, engWord: string, editMode: boolean, id}}
     */
    createNewAiWord(listId: any, sideOne: string, sideTwo: string) {
        return {
            id: uuidv4(),
            engWord: sideOne,
            prevEngWord: sideOne,
            rusWord: sideTwo,
            prevRusWord: sideTwo,
            editMode: true,
            listId: listId,
            loading: false,
            created: moment(new Date()).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        }
    },

    /**
     * Создание нового слова
     * @param
     * @returns {{prewEngWord: string, rusWord: string, prewRusWord: string, engWord: string, editMode: boolean, id}}
     */
    createNewWordCleanByRegExp(listId: any, sideOne: string, sideTwo: string) {
        const pattern = WordUtils.getWordPattern();

        const inverseRegexp = new RegExp(`[^${pattern}]`, 'g');

        const cleanedSideOne = sideOne.replace(inverseRegexp, '');
        const cleanedSideTwo = sideTwo.replace(inverseRegexp, '');

        return {
            id: uuidv4(),
            engWord: sideOne,
            prevEngWord: sideOne,
            rusWord: sideTwo,
            prevRusWord: sideTwo,
            editMode: true,
            listId: listId,
            loading: false,
            created: moment(new Date()).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        }
    },

    /**
     * Новая сущность, созданная на фронте имеет id != number. Сущность из бд id = number
     * @param id
     * @returns {boolean}
     */
    isNewEntity(id: any) {
        return typeof id !== 'number'
    },

    /**
     * Преобразуем слова в объект на фронте
     * @param data
     * @returns {*|*[]}
     */
    parseWorlds: (data: any[]) => data?.map((word: any) => WordUtils.parseWorld(word)) || [],

    /**
     * Преобразуем слово в объект на фронте
     * @param word
     * @returns {*|*[]}
     */
    parseWorld: (word: any) => {
        return {
            id: word.id,
            engWord: word.engWord,
            prevEngWord: word.engWord,
            rusWord: word.rusWord,
            prevRusWord: word.rusWord,
            editMode: false,
            loading: false,
            listId: word.listId,
            created: word.created
        }
    },

    loadWord: (word: any, value: boolean) => {
        return {
            ...word,
            loading: value
        }
    },

    clearNotSavedWords: (words: any[]) => {
        return words.map((w: any) => {
            if (w.editMode) {
                return {
                    ...w,
                    engWord: w.prevEngWord ? w.prevEngWord : '',
                    rusWord: w.prevRusWord ? w.prevRusWord : '',
                    editMode: false
                }
            }
            return w
        }).filter((w) => !WordUtils.isNewEntity(w.id))
    },

    removeDuplicates: (words: any[]) => {
        return words.filter((value: any, index: number, self: any[]) => index === self.findIndex((t: any) => t.id === value.id))
    },

    /**
     * Валидация слов по паттерну
     * @param word - слово (строка)
     * @returns {boolean}
     */
    validateWordString: (word: string) => {
        const myRegexp = new RegExp(WordUtils.getWordPattern(), 'g')
        return !!word.match(myRegexp)
    },

    getWordPattern: () => {
        return `^[${pL}0-9\\s()-.?¿'!¡,:：！？。_\\/]{1,250}$`
    },

    getWordsPattern: () => {
        return `^(([${pL}0-9\\s()-.?¿'!¡,:：！？。_\\/]{1,250}) - ([${pL}0-9\\s()-.?¿'!¡,:：！？。_\\/]{1,250}))$`
    },

    /**
     * Валидация слов по паттерну
     * @param word - слово
     * @returns {boolean}
     */
    validateWord: (word: any) => {
        return WordUtils.validateWordString(word.engWord) && WordUtils.validateWordString(word.rusWord)
    },

    wordErrorMsg: (msg: string) => {
        notification.open({
            type: 'error',
            message: 'Ошибка',
            description: msg
        })
    },

    mergeWords: (memory: any[], updated: any[]) => {
        //Возможно можно сделать более оптимально
        const arr = [...memory, ...updated]
        return Object.values(
            arr.reduce((acc, obj) => ({ ...acc, [obj.id]: obj }), {})
        )
    }
}

export default WordUtils
